/* eslint-disable array-bracket-newline */
import { Routes } from '@angular/router';

import { HomeComponent } from './components/home/home.component';

export default <Routes>[
  { path: '', pathMatch: 'full', component: HomeComponent, data: HomeComponent.ROUTE_DATA }
];
